/**
 * ERGO Theme - Custom Global Scripts
 * Add ERGO namespace to separate which sections we created.
 */

const ErgoTheme = {
  init: function () {
    console.log('ERGO Theme Initialized');
    try { this.bindEvents(); } catch (e) { console.error('Error in bindEvents:', e); }
    try { this.initTrustBarSlider(); } catch (e) { console.error('Error in initTrustBarSlider:', e); }
    try { this.initFeatureCardsSlider(); } catch (e) { console.error('Error in initFeatureCardsSlider:', e); }
    try { this.initCollectionsProgress(); } catch (e) { console.error('Error in initCollectionsProgress:', e); }
    try { this.initTextReveal(); } catch (e) { console.error('Error in initTextReveal:', e); }
    try { this.initProductTabs(); } catch (e) { console.error('Error in initProductTabs:', e); }
    try { this.initScrollAnimations(); } catch (e) { console.error('Error in initScrollAnimations:', e); }
    try { this.initValuePropsSlider(); } catch (e) { console.error('Error in initValuePropsSlider:', e); }
    try { this.initExploreZone(); } catch (e) { console.error('Error in initExploreZone:', e); }
    try { this.initTestimonialsSlider(); } catch (e) { console.error('Error in initTestimonialsSlider:', e); }
    try { this.initSeparatesUsLine(); } catch (e) { console.error('Error in initSeparatesUsLine:', e); }
    try { this.initTeamProfile(); } catch (e) { console.error('Error in initTeamProfile:', e); }
    try { this.initChairFinder(); } catch (e) { console.error('Error in initChairFinder:', e); }
    try { this.initMedicallyEndorsed(); } catch (e) { console.error('Error in initMedicallyEndorsed:', e); }
    try { this.initVideoMarquee(); } catch (e) { console.error('Error in initVideoMarquee:', e); }
    try { this.initAjaxCart(); } catch (e) { console.error('Error in initAjaxCart:', e); }
    try { this.initHoverVideos(); } catch (e) { console.error('Error in initHoverVideos:', e); }
  },

  bindEvents: function () {
    // ERGO: Add global event listeners here
  },

  initHoverVideos: function () {
    const cards = document.querySelectorAll('.js-hover-video-card');
    cards.forEach(card => {
      const video = card.querySelector('video');
      const playBtn = card.querySelector('.ergo-performers__play-btn');
      if (!video) return;

      // Ensure video starts muted and paused (clean thumbnail frame)
      video.muted = false;
      video.playsInline = true;
      video.loop = false;
      video.controls = false;

      // Seek to a clean first frame
      video.addEventListener('loadedmetadata', () => {
        video.currentTime = 0;
      });

      const enterPlayState = () => {
        video.controls = true;
        video.muted = false;
        card.classList.add('is-playing');
        video.play().catch(err => {
          // If unmuted autoplay blocked, fall back to muted
          video.muted = true;
          video.play().catch(() => {});
        });
      };

      const exitPlayState = () => {
        video.controls = false;
        video.muted = true;
        video.currentTime = 0;
        card.classList.remove('is-playing');
      };

      // Play button click
      if (playBtn) {
        playBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          // Pause any other playing cards first
          document.querySelectorAll('.js-hover-video-card.is-playing').forEach(otherCard => {
            if (otherCard !== card) {
              const otherVideo = otherCard.querySelector('video');
              if (otherVideo) {
                otherVideo.pause();
                otherVideo.controls = false;
                otherVideo.currentTime = 0;
              }
              otherCard.classList.remove('is-playing');
            }
          });

          enterPlayState();
        });
      }

      // When video ends — restore thumbnail state
      video.addEventListener('ended', () => {
        exitPlayState();
      });

      // When user pauses via native controls — restore play button
      video.addEventListener('pause', () => {
        if (!video.ended) {
          exitPlayState();
        }
      });
    });
  },

  /**
   * ============================================================================
   * ERGO COLLECTIONS PROGRESS BAR
   * Description: Listens to native scroll on the collections grid and fills the bar.
   * ============================================================================
   */
  initCollectionsProgress: function () {
    var $grid = $('.ergo-collections__grid');
    var $fill = $('.ergo-collections__progress-fill');

    if ($grid.length && $fill.length) {
      $grid.on('scroll', function () {
        var scrollLeft = $(this).scrollLeft();
        var maxScroll = this.scrollWidth - this.clientWidth;

        if (maxScroll > 0) {
          var percentage = ((scrollLeft + this.clientWidth) / this.scrollWidth) * 100;
          $fill.css('width', percentage + '%');
        }
      });

      // Initialize width on load (in case they start at 0)
      $grid.trigger('scroll');
      
      // Update on resize
      $(window).on('resize', function () {
        $grid.trigger('scroll');
      });
    }
  },

  /**
   * ============================================================================
   * ERGO TEXT REVEAL
   * Description: Line by line text reveal on scroll
   * ============================================================================
   */
  initTextReveal: function () {
    const containers = document.querySelectorAll('.js-ergo-text-reveal');
    if (!containers.length) return;

    class ErgoTextReveal {
      constructor(container) {
        this.container = container;
        this.textNodes = container.querySelectorAll('.ergo-reveal-text');
        this.words = [];

        this.init();
        this.bindEvents();
      }

      init() {
        this.textNodes.forEach(node => {
          const text = node.textContent;
          const words = text.split(/(\s+)/);
          node.innerHTML = ''; // clear original text
          words.forEach(word => {
            if (word.trim() === '') {
              node.appendChild(document.createTextNode(word));
            } else {
              const span = document.createElement('span');
              span.className = 'ergo-reveal-word';
              span.textContent = word;
              node.appendChild(span);
              this.words.push(span);
            }
          });
        });

        // Trigger initial check
        setTimeout(() => this.handleScroll(), 100);
      }

      bindEvents() {
        window.addEventListener('scroll', () => {
          if (!this.ticking) {
            window.requestAnimationFrame(() => {
              this.handleScroll();
              this.ticking = false;
            });
            this.ticking = true;
          }
        }, { passive: true });
        
        window.addEventListener('resize', () => {
          this.handleScroll();
        });
      }

      handleScroll() {
        if (this.words.length === 0) return;

        const containerRect = this.container.getBoundingClientRect();
        
        // Start revealing when the container enters the bottom 20% of the screen
        const startReveal = window.innerHeight * 0.8;
        
        // Finish revealing when the bottom of the container reaches the top 40% of the screen
        const endReveal = window.innerHeight * 0.4;
        
        // The total scroll distance for the reveal
        const scrollRange = startReveal - (endReveal - containerRect.height);
        
        let progress = (startReveal - containerRect.top) / scrollRange;
        progress = Math.max(0, Math.min(1, progress));
        
        const activeCount = Math.floor(progress * this.words.length);
        
        this.words.forEach((word, index) => {
          if (index < activeCount) {
            word.classList.add('is-active');
          } else {
            word.classList.remove('is-active');
          }
        });
      }
    }

    containers.forEach(container => new ErgoTextReveal(container));
  },

  /**
   * ============================================================================
   * ERGO TRUST BAR SLIDER
   * Description: Initializes the Slick Carousel for the Trust Bar section ONLY 
   * on mobile devices. Destroys the carousel automatically on desktop screens.
   * ============================================================================
   */
  initTrustBarSlider: function () {
    if (typeof jQuery !== 'undefined' && jQuery.fn.slick) {
      $('.ergo-trust-bar__grid').each(function () {
        var $slider = $(this);

        if (!$slider.hasClass('slick-initialized')) {
          $slider.slick({
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            autoplay: true,
            autoplaySpeed: 3000,
            infinite: true,
            swipeToSlide: true,
            adaptiveHeight: true,
            responsive: [
              {
                breakpoint: 900,
                settings: "unslick"
              }
            ]
          });
        }
      });
    } else {
      // If Slick isn't ready yet, retry in 100ms
      setTimeout(this.initTrustBarSlider.bind(this), 100);
    }
  },

  /**
   * ============================================================================
   * ERGO FEATURE CARDS SLIDER
   * ============================================================================
   */
  initFeatureCardsSlider: function () {
    if (typeof jQuery !== 'undefined' && jQuery.fn.slick) {
      $('.efc-inner').each(function () {
        var $slider = $(this);

        if (!$slider.hasClass('slick-initialized')) {
          $slider.slick({
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<button type="button" class="efc-arrow efc-arrow--prev" aria-label="Previous"><svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"></polyline></svg></button>',
            nextArrow: '<button type="button" class="efc-arrow efc-arrow--next" aria-label="Next"><svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"></polyline></svg></button>',
            dots: false,
            autoplay: true,
            autoplaySpeed: 3000,
            infinite: true,
            swipeToSlide: true,
            responsive: [
              {
                breakpoint: 900,
                settings: "unslick"
              }
            ]
          });
        }
      });
    } else {
      setTimeout(this.initFeatureCardsSlider.bind(this), 100);
    }
  },

  /**
   * ============================================================================
   * ERGO PRODUCT TABS & SLIDER
   * ============================================================================
   */
  initProductTabs: function () {
    // 1. Initialize Slick Sliders
    if (typeof jQuery !== 'undefined' && jQuery.fn.slick) {
      $('.js-ergo-product-slider').each(function () {
        var $slider = $(this);
        if (!$slider.hasClass('slick-initialized')) {
          var isAutoplay = $slider.attr('data-autoplay') === 'true';
          $slider.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: isAutoplay,
            autoplaySpeed: 4000,
            arrows: false,
            dots: true,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 2
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1
                }
              }
            ]
          });
        }
      });
    } else {
      setTimeout(this.initProductTabs.bind(this), 100);
      return;
    }

    // 2. Tab Switching Logic
    const tabBtns = document.querySelectorAll('.ergo-tab-btn');
    tabBtns.forEach(btn => {
      btn.addEventListener('click', function () {
        const section = this.closest('.ergo-tabs-container') || this.closest('.ergo-section');
        if (!section) return;

        section.querySelectorAll('.ergo-tab-btn').forEach(b => b.classList.remove('is-active'));
        section.querySelectorAll('.ergo-tab-pane').forEach(p => p.classList.remove('is-active'));

        this.classList.add('is-active');

        const targetId = this.getAttribute('data-target');
        const targetPane = document.getElementById(targetId);
        if (targetPane) {
          targetPane.classList.add('is-active');
          if (typeof jQuery !== 'undefined' && jQuery.fn.slick) {
            const $slider = $(targetPane).find('.js-ergo-product-slider');
            if ($slider.hasClass('slick-initialized')) {
              // Sliders in inactive tabs are slick-initialized while display:none (width 0),
              // so a single setPosition() called immediately can still use stale slide widths.
              // Defer past the fadeIn animation/reflow, and also nudge Slick's own resize
              // handler so it fully re-measures the now-visible container.
              setTimeout(function () {
                $slider.slick('setPosition');
                $(window).trigger('resize');
              }, 60);
            }
          }
        }
      });
    });
  },

  /**
   * ============================================================================
   * ERGO SCROLL ANIMATIONS
   * ============================================================================
   */
  initScrollAnimations: function () {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.js-rise-up, .js-expand-in').forEach(el => el.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0px',
      threshold: 0.15
    });

    document.querySelectorAll('.js-rise-up, .js-expand-in').forEach(el => observer.observe(el));
  },

  /**
   * ============================================================================
   * ERGO VALUE PROPS SLIDER
   * ============================================================================
   */
  initValuePropsSlider: function () {
    if (typeof jQuery !== 'undefined' && jQuery.fn.slick) {
      $('.js-ergo-value-props-slider').each(function () {
        var $slider = $(this);

        function checkValuePropsSlider() {
          if (window.innerWidth <= 768) {
            if (!$slider.hasClass('slick-initialized')) {
              $slider.slick({
                slidesToShow: 2,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 3000,
                arrows: false,
                dots: true,
                responsive: [
                  {
                    breakpoint: 480,
                    settings: {
                      slidesToShow: 1
                    }
                  }
                ]
              });
            }
          } else {
            if ($slider.hasClass('slick-initialized')) {
              $slider.slick('unslick');
            }
          }
        }

        checkValuePropsSlider();
        $(window).on('resize', checkValuePropsSlider);
      });
    } else {
      setTimeout(this.initValuePropsSlider.bind(this), 100);
    }
  },

  /**
   * ============================================================================
   * ERGO EXPLORE ZONE (ACCORDION / SLIDER)
   * ============================================================================
   */
  initExploreZone: function () {
    // Desktop Hover Accordion
    const $items = $('.ergo-explore__item');
    $items.on('mouseenter', function () {
      if (window.innerWidth > 768) {
        $items.removeClass('is-active');
        $(this).addClass('is-active');
      }
    });

    // Mobile Slick Slider with Progress Bar
    if (typeof jQuery !== 'undefined' && jQuery.fn.slick) {
      $('.js-ergo-explore-slider').each(function () {
        const $slider = $(this);
        const $progressBar = $slider.closest('.ergo-explore__wrapper').find('.js-ergo-explore-progress');

        function updateProgress(slick, currentSlide) {
          const calc = ((currentSlide + 1) / slick.slideCount) * 100;
          $progressBar.css('width', calc + '%');
        }

        function toggleSlick() {
          if (window.innerWidth <= 768) {
            if (!$slider.hasClass('slick-initialized')) {
              $slider.on('init', function (event, slick) {
                updateProgress(slick, 0);
              });

              $slider.slick({
                slidesToShow: 1.15,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                infinite: false
              });

              $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                updateProgress(slick, nextSlide);
              });
            }
          } else {
            if ($slider.hasClass('slick-initialized')) {
              $slider.slick('unslick');
            }
          }
        }

        toggleSlick();
        $(window).on('resize', function () {
          clearTimeout(window.ergoExploreResizeTimer);
          window.ergoExploreResizeTimer = setTimeout(toggleSlick, 200);
        });
      });
    } else {
      setTimeout(this.initExploreZone.bind(this), 100);
    }
  },

  /**
   * ============================================================================
   * ERGO TESTIMONIALS SLIDER
   * ============================================================================
   */
  initTestimonialsSlider: function () {
    if (typeof jQuery !== 'undefined' && jQuery.fn.slick) {
      $('.js-ergo-testimonials-slider').each(function () {
        const $slider = $(this);
        if (!$slider.hasClass('slick-initialized')) {
          $slider.slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            infinite: true,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 2
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1
                }
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 1
                }
              }
            ]
          });
        }
      });
    } else {
      setTimeout(this.initTestimonialsSlider.bind(this), 100);
    }
  },

  /**
   * ============================================================================
   * ERGO SEPARATES US - DYNAMIC SVG LINE & SCROLL ANIMATION
   * ============================================================================
   */
  initSeparatesUsLine: function () {
    const list = document.querySelector('.js-ergo-separates-list');
    const svg = document.querySelector('.js-ergo-separates-svg');
    const path = document.querySelector('.js-ergo-separates-path');

    if (!list || !svg || !path) return;

    function drawPath() {
      const items = document.querySelectorAll('.js-separates-item');
      if (items.length === 0) return;

      const isMobile = window.innerWidth <= 900;

      const listRect = list.getBoundingClientRect();
      const radius = isMobile ? 10 : 25; // smaller corner radius on mobile
      const gapX = isMobile ? 12 : 40; // smaller gap on mobile
      const gapY = isMobile ? 15 : 25; // smaller vertical gap on mobile

      let d = '';

      items.forEach((item, index) => {
        const rect = item.getBoundingClientRect();

        // Coordinates relative to the SVG container (list)
        const yBottom = rect.bottom - listRect.top;
        const xLeft = rect.left - listRect.left;
        const xRight = rect.right - listRect.left;

        const isLeftAligned = item.classList.contains('ergo-separates__item--left');

        // Lines pass outside the pills
        const rightLineX = xRight + gapX;
        const leftLineX = xLeft - gapX;
        const horizontalY = yBottom + gapY;

        if (index === 0) {
          // Start path high above the first item on the right
          if (isLeftAligned) {
            d += `M ${rightLineX} 0 `;
            d += `L ${rightLineX} ${horizontalY - radius} `;
            if (index !== items.length - 1) {
              d += `Q ${rightLineX} ${horizontalY} ${rightLineX - radius} ${horizontalY} `;
            }
          } else {
            d += `M ${leftLineX} 0 `;
            d += `L ${leftLineX} ${horizontalY - radius} `;
            if (index !== items.length - 1) {
              d += `Q ${leftLineX} ${horizontalY} ${leftLineX + radius} ${horizontalY} `;
            }
          }
        } else {
          // Connect from previous item
          const prevItem = items[index - 1];
          const prevRect = prevItem.getBoundingClientRect();
          const prevYBottom = prevRect.bottom - listRect.top;
          const prevIsLeft = prevItem.classList.contains('ergo-separates__item--left');

          const prevHorizontalY = prevYBottom + gapY;

          if (prevIsLeft && !isLeftAligned) {
            // Previous was left aligned (line is on its right, moving left)
            d += `L ${leftLineX + radius} ${prevHorizontalY} `;
            d += `Q ${leftLineX} ${prevHorizontalY} ${leftLineX} ${prevHorizontalY + radius} `;
            d += `L ${leftLineX} ${horizontalY - radius} `;
            if (index !== items.length - 1) {
              d += `Q ${leftLineX} ${horizontalY} ${leftLineX + radius} ${horizontalY} `;
            }
          } else if (!prevIsLeft && isLeftAligned) {
            // Previous was right aligned (line is on its left, moving right)
            d += `L ${rightLineX - radius} ${prevHorizontalY} `;
            d += `Q ${rightLineX} ${prevHorizontalY} ${rightLineX} ${prevHorizontalY + radius} `;
            d += `L ${rightLineX} ${horizontalY - radius} `;
            if (index !== items.length - 1) {
              d += `Q ${rightLineX} ${horizontalY} ${rightLineX - radius} ${horizontalY} `;
            }
          } else {
            // same alignment (fallback, go straight down)
            if (isLeftAligned) {
              d += `L ${rightLineX} ${horizontalY - radius} `;
              if (index !== items.length - 1) {
                d += `Q ${rightLineX} ${horizontalY} ${rightLineX - radius} ${horizontalY} `;
              }
            } else {
              d += `L ${leftLineX} ${horizontalY - radius} `;
              if (index !== items.length - 1) {
                d += `Q ${leftLineX} ${horizontalY} ${leftLineX + radius} ${horizontalY} `;
              }
            }
          }
        }

        // Final tail
        if (index === items.length - 1) {
          if (isLeftAligned) {
            d += `L ${rightLineX} ${horizontalY + 100} `; // Continue going straight down
          } else {
            d += `L ${leftLineX} ${horizontalY + 100} `; // Continue going straight down
          }
        }
      });

      path.setAttribute('d', d);

      // Initialize stroke dash properties
      const length = path.getTotalLength();
      path.style.strokeDasharray = length;
      path.style.strokeDashoffset = length; // Hide initially
    }
    function updateScroll() {
      const listRect = list.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      // Calculate scroll progress (0 to 1) based on section visibility
      const scrollStart = windowHeight * 0.7; // Start animating when top of list is 70% down screen
      const scrolled = scrollStart - listRect.top;

      const totalScrollable = listRect.height;
      let percentage = scrolled / totalScrollable;

      percentage = Math.max(0, Math.min(1, percentage));

      const length = path.getTotalLength();
      path.style.strokeDashoffset = length - (length * percentage);
    }

    // Initialize after a small delay to ensure layout is complete
    setTimeout(() => {
      drawPath();
      updateScroll();
    }, 200);

    window.addEventListener('resize', () => {
      drawPath();
      updateScroll();
    });

    window.addEventListener('scroll', () => {
      // throttle requestAnimationFrame
      if (!this.separatesTicking) {
        window.requestAnimationFrame(() => {
          updateScroll();
          this.separatesTicking = false;
        });
        this.separatesTicking = true;
      }
    }, { passive: true });
  },

  initTeamProfile: function () {
    const section = document.querySelector('.js-ergo-team-section');
    if (!section) return;

    const dataScript = section.querySelector('.js-team-data');
    if (!dataScript) return;

    let teamData = [];
    try {
      teamData = JSON.parse(dataScript.textContent);
    } catch (e) {
      console.error('Error parsing team data', e);
      return;
    }

    const watermark = section.querySelector('.js-team-watermark');
    const jobLabel = section.querySelector('.js-team-job-label');
    const mainImage = section.querySelector('.js-team-main-image');
    const slides = section.querySelectorAll('.js-team-slide');
    const dots = section.querySelectorAll('.js-team-dot');

    let isAnimating = false;

    const activateSlide = (index) => {
      if (isAnimating) return;
      const targetSlide = slides[index];
      if (!targetSlide || targetSlide.classList.contains('is-active')) return;

      const data = teamData[index];
      if (!data) return;

      isAnimating = true;

      // Update active class on slides
      slides.forEach(s => s.classList.remove('is-active'));
      targetSlide.classList.add('is-active');

      // Update active class on dots
      dots.forEach((dot, dotIndex) => {
        if (dotIndex === index) {
          dot.classList.add('is-active');
        } else {
          dot.classList.remove('is-active');
        }
      });

      // Animate background elements out
      mainImage.classList.add('is-animating');
      watermark.style.opacity = 0;
      if (jobLabel) jobLabel.style.opacity = 0;

      // Wait for fade out, then swap data and animate in
      setTimeout(() => {
        watermark.textContent = data.name.toUpperCase();
        if (jobLabel) jobLabel.textContent = data.job.toUpperCase();

        mainImage.innerHTML = data.html; // Swap entire HTML (img or svg)

        // Small delay for DOM update, then animate in
        setTimeout(() => {
          mainImage.classList.remove('is-animating');
          watermark.style.opacity = 1;
          if (jobLabel) jobLabel.style.opacity = 1;
          isAnimating = false;
        }, 50);

      }, 400); // 0.4s fade out
    };

    slides.forEach((slide, index) => {
      slide.addEventListener('click', () => activateSlide(index));
    });

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => activateSlide(index));
    });
  },

  initChairFinder: function () {
    const sections = document.querySelectorAll('.js-ergo-finder');

    sections.forEach(section => {
      const stack = section.querySelector('.js-finder-stack');
      const cards = section.querySelectorAll('.js-finder-card');

      if (!stack) return;
      if (cards.length === 0) return;

      let activeIndex = Math.floor(cards.length / 2); // Start in the middle if possible

      const updateCards = () => {
        cards.forEach((card, index) => {
          // Remove all state classes
          card.classList.remove('is-active', 'is-next-1', 'is-prev-1', 'is-next-2', 'is-prev-2', 'is-hidden-left', 'is-hidden-right');

          const diff = index - activeIndex;

          if (diff === 0) {
            card.classList.add('is-active');
          } else if (diff === 1) {
            card.classList.add('is-next-1');
          } else if (diff === -1) {
            card.classList.add('is-prev-1');
          } else if (diff === 2) {
            card.classList.add('is-next-2');
          } else if (diff === -2) {
            card.classList.add('is-prev-2');
          } else if (diff > 2) {
            card.classList.add('is-hidden-right');
          } else if (diff < -2) {
            card.classList.add('is-hidden-left');
          }
        });
      };

      const nextCard = () => {
        if (activeIndex < cards.length - 1) {
          activeIndex++;
          updateCards();
        }
      };

      const prevCard = () => {
        if (activeIndex > 0) {
          activeIndex--;
          updateCards();
        }
      };

      updateCards(); // Initialize layout

      // Drag / Swipe Logic
      let startX = 0;
      let isDragging = false;

      stack.addEventListener('mousedown', (e) => {
        isDragging = true;
        startX = e.clientX;
      });

      window.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        const diffX = startX - e.clientX;

        // If dragged left enough
        if (diffX > 50) {
          nextCard();
          isDragging = false;
        } else if (diffX < -50) {
          prevCard();
          isDragging = false;
        }
      });

      window.addEventListener('mouseup', () => {
        isDragging = false;
      });

      // Touch support
      stack.addEventListener('touchstart', (e) => {
        isDragging = true;
        startX = e.touches[0].clientX;
      });

      window.addEventListener('touchmove', (e) => {
        if (!isDragging) return;
        const diffX = startX - e.touches[0].clientX;

        if (diffX > 50) {
          nextCard();
          isDragging = false;
        } else if (diffX < -50) {
          prevCard();
          isDragging = false;
        }
      });

      window.addEventListener('touchend', () => {
        isDragging = false;
      });

      // Scroll interaction: map wheel events to next/prev inside the section
      let lastWheelTime = 0;
      section.addEventListener('wheel', (e) => {
        // only trigger once every 500ms
        const now = Date.now();
        if (now - lastWheelTime < 500) return;

        if (e.deltaY > 0) {
          // scroll down -> next card
          if (activeIndex < cards.length - 1) {
            e.preventDefault(); // prevent actual scrolling while interacting with cards
            nextCard();
            lastWheelTime = now;
          }
        } else if (e.deltaY < 0) {
          // scroll up -> prev card
          if (activeIndex > 0) {
            e.preventDefault();
            prevCard();
            lastWheelTime = now;
          }
        }
      }, { passive: false });
    });
  },

  initMedicallyEndorsed: function () {
    const sections = document.querySelectorAll('.js-ergo-medically');

    sections.forEach(section => {
      const outer = section.querySelector('.js-medically-outer');
      const cards = Array.from(section.querySelectorAll('.js-medically-card'));

      if (!outer || cards.length === 0) return;

      // Assign sides alternating left and right
      cards.forEach((card, i) => {
        card.setAttribute('data-side', i % 2 === 0 ? 'left' : 'right');
        if (i < 2) {
          card.style.opacity = '1';
          card.style.transform = 'none';
          card.style.top = i === 0 ? '20%' : '55%';
        } else {
          card.style.opacity = '0';
          card.style.transform = 'translateY(100vh)'; // Start hidden below screen
        }
      });

      // Physics configuration
      const STAGGER_VH = 40; // Vertical space between cards
      const TRAVEL_VH = 200; // Total travel distance per card (100vh below to 100vh above)

      const animatedCardsCount = Math.max(0, cards.length - 2);
      const maxScrollVh = animatedCardsCount > 0 ? TRAVEL_VH + (animatedCardsCount - 1) * STAGGER_VH : 0;
      
      outer.style.minHeight = (100 + maxScrollVh) + 'vh';

      const onScroll = () => {
        const rect = outer.getBoundingClientRect();
        // Distance scrolled into the outer container (in pixels)
        const scrolledPx = -rect.top;
        const winH = window.innerHeight;

        // Convert scrolled pixels to VH units
        const scrolledVh = (scrolledPx / winH) * 100;

        cards.forEach((card, i) => {
          if (i < 2) {
            if (maxScrollVh > 0 && scrolledVh > 0 && scrolledVh <= maxScrollVh) {
              card.style.transform = `translateY(-${scrolledVh}vh)`;
            } else if (scrolledVh > maxScrollVh) {
              card.style.transform = `translateY(-${maxScrollVh}vh)`;
            } else {
              card.style.transform = 'none';
            }
            return;
          }

          const startVh = (i - 2) * STAGGER_VH;

          // How far this card has travelled in its own timeline (in vh)
          const cardTravelVh = scrolledVh - startVh;

          if (cardTravelVh <= 0) {
            // Below screen (waiting to enter)
            card.style.opacity = '0';
            card.style.transform = 'translateY(100vh)';
          } else if (cardTravelVh >= TRAVEL_VH) {
            // Above screen (finished exiting)
            card.style.opacity = '0';
            card.style.transform = 'translateY(-100vh)';
          } else {
            // Moving smoothly across the screen
            const localP = cardTravelVh / TRAVEL_VH; // 0 to 1

            // Fade in during the first 15%, fade out during the last 15%
            let opacity = 1;
            if (localP < 0.15) opacity = localP / 0.15;
            if (localP > 0.85) opacity = (1 - localP) / 0.15;

            card.style.opacity = opacity;

            // Linear movement from 100vh (bottom) to -100vh (top)
            const yPos = 100 - (localP * 200);
            card.style.transform = `translateY(${yPos}vh)`;
          }
        });
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', () => {
        outer.style.minHeight = (100 + maxScrollVh) + 'vh';
        onScroll();
      }, { passive: true });

      onScroll();
    });
  },

  initVideoMarquee: function () {
    const sections = document.querySelectorAll('.js-ergo-video-marquee');

    sections.forEach(section => {
      const scene = section.querySelector('.ergo-video-marquee__scene');
      const track = section.querySelector('.js-marquee-track');
      let items = Array.from(section.querySelectorAll('.js-marquee-item'));

      if (!track || items.length === 0) return;

      const isMobile = window.matchMedia('(max-width: 768px)').matches;

      // iOS Safari breaks on this section (works fine on Android/desktop) because the
      // 3D coverflow keeps up to 16 videos autoplaying at once with a webkit mask-image,
      // which Safari can't handle reliably. Mobile gets a lighter flat scrolling strip
      // instead, with only on-screen videos actually playing.
      if (isMobile) {
        track.classList.add('is-mobile-marquee');

        items.forEach(item => {
          track.appendChild(item.cloneNode(true));
        });
        items = Array.from(section.querySelectorAll('.js-marquee-item'));

        items.forEach(item => {
          const v = item.querySelector('.js-marquee-video');
          if (v) { v.muted = true; v.controls = false; }
        });

        if (window.IntersectionObserver) {
          const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              const v = entry.target.querySelector('.js-marquee-video');
              if (!v) return;
              if (entry.isIntersecting) {
                v.play().catch(() => { });
              } else {
                v.pause();
              }
            });
          }, { threshold: 0.15 });
          items.forEach(item => observer.observe(item));
        } else {
          items.forEach(item => {
            const v = item.querySelector('.js-marquee-video');
            if (v) v.play().catch(() => { });
          });
        }

        return;
      }

      const SPEED = (parseFloat(track.getAttribute('data-speed')) || 3) * 0.05;  // slow cinematic
      const CARD_W = 320;
      const CARD_H = 500;
      const RADIUS = 1100;   // larger = wider, full-screen spread
      const TOTAL_ITEMS = 16; // 16 items total to close the loop
      const ANGLE_STEP = 22.5; // 360 / 16 = 22.5
      const SHOW_HALF = 90;    // show cards until they reach the side edges

      const originalLen = items.length;
      while (items.length < TOTAL_ITEMS) {
        const clone = items[items.length % originalLen].cloneNode(true);
        track.appendChild(clone);
        items = Array.from(section.querySelectorAll('.js-marquee-item'));
      }

      // Re-query after cloning
      items = Array.from(section.querySelectorAll('.js-marquee-item'));

      // Autoplay all videos
      items.forEach(item => {
        const v = item.querySelector('.js-marquee-video');
        if (v) { 
          v.muted = true; 
          v.controls = false; 
          v.style.pointerEvents = 'auto';
          v.play().catch(() => { }); 
        }
        item.addEventListener('mouseenter', () => { 
          isHovered = true; 
          if (v) {
            v.controls = true;
            v.muted = false; // Optional: unmute on hover? Usually better to leave muted and let user unmute via controls
          }
        });
        item.addEventListener('mouseleave', () => { 
          isHovered = false; 
          if (v) v.controls = false; 
        });
      });

      // Make scene the 3D context
      if (scene) {
        scene.style.perspective = '800px';   /* stronger depth effect */
        scene.style.perspectiveOrigin = '50% 50%';
        scene.style.overflow = 'visible';
      }

      track.style.position = 'relative';
      track.style.height = CARD_H + 'px';
      track.style.display = 'block';
      track.style.transformStyle = 'preserve-3d';

      items.forEach(item => {
        item.style.position = 'absolute';
        item.style.top = '0';
        item.style.left = '0';
        item.style.width = CARD_W + 'px';
        item.style.height = CARD_H + 'px';
        item.style.margin = '0';
        item.style.pointerEvents = 'auto';
      });

      let isHovered = false;
      let angleOffset = 0;

      const render = () => {
        if (!isHovered) angleOffset += SPEED;

        const cx = section.offsetWidth / 2;

        items.forEach((item, i) => {
          // Angular position on the cylinder
          let theta = (i * ANGLE_STEP - angleOffset) % 360;
          if (theta > 180) theta -= 360;
          if (theta < -180) theta += 360;

          const rad = theta * Math.PI / 180;
          // Concave cylinder: center is at the back (θ=0 → Z=-RADIUS), edges forward
          const posX = Math.sin(rad) * RADIUS;
          const posZ = -Math.cos(rad) * RADIUS;
          // Card face always points toward the viewer
          const rotY = -theta;

          if (Math.abs(theta) > SHOW_HALF) {
            item.style.visibility = 'hidden';
            return;
          }
          item.style.visibility = 'visible';
          item.style.zIndex = String(Math.round(posZ + RADIUS));
          item.style.transform = `translateX(${cx + posX - CARD_W / 2}px) translateZ(${posZ}px) rotateY(${rotY}deg)`;
        });

        requestAnimationFrame(render);
      };

      setTimeout(render, 150);
    });
  },

  initAjaxCart: function() {
    document.addEventListener('submit', function(e) {
      if (e.target.matches('.js-ergo-ajax-cart-form')) {
        e.preventDefault();
        
        const form = e.target;
        const btn = form.querySelector('button[type="submit"]');
        const originalText = btn.innerHTML;
        
        btn.innerHTML = 'ADDING...';
        btn.disabled = true;

        const formData = new FormData(form);

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          body: formData,
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(response => {
          if (!response.ok) throw new Error('Network response was not ok');
          return response.json();
        })
        .then(data => {
          btn.innerHTML = 'ADDED!';
          
          // Fetch the current page (which we know has the cart drawer enabled) to grab the freshly updated cart drawer HTML.
          // We can't fetch '/cart' because the cart drawer is disabled on the cart page!
          const fetchUrl = window.location.pathname + '?_update_cart=' + new Date().getTime();
          fetch(fetchUrl)
            .then(res => res.text())
            .then(html => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              
              // Find the cart drawer container in the fetched HTML specifically inside #site-cart
              const newCartContainer = doc.querySelector('#site-cart .site-nav-container-last');
              const currentCartContainer = document.querySelector('#site-cart .site-nav-container-last');
              
              // Replace current cart HTML with the updated one
              if (newCartContainer && currentCartContainer) {
                currentCartContainer.innerHTML = newCartContainer.innerHTML;
              }
              
              // Update the bubble count in the header
              const countEl = document.getElementById('ErgoCartCount');
              const newCountEl = doc.getElementById('ErgoCartCount');
              if (countEl && newCountEl) {
                const count = parseInt(newCountEl.textContent.trim(), 10) || 0;
                countEl.textContent = count;
                countEl.style.display = count > 0 ? 'flex' : 'none';
              }
              
              // Now that the HTML is injected, smoothly open the drawer!
              ErgoTheme.openCartDrawer(true);
              
              setTimeout(() => {
                btn.innerHTML = originalText;
                btn.disabled = false;
              }, 2000);
            })
            .catch(err => {
              console.error('Error fetching updated cart HTML:', err);
            });
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
          btn.innerHTML = 'ERROR';
          setTimeout(() => {
            btn.innerHTML = originalText;
            btn.disabled = false;
          }, 2000);
        });
      }
    });
    
    // Also bind header cart icon to manually open the drawer if theme.js fails
    const cartIcon = document.getElementById('ErgoCartIcon');
    if (cartIcon) {
      cartIcon.addEventListener('click', (e) => {
        e.preventDefault();
        ErgoTheme.openCartDrawer();
      });
    }
  },

  openCartDrawer: function(isSilent = false) {
    const drawer = document.getElementById('site-cart');
    if (!drawer) {
      console.warn('Cart drawer element #site-cart not found on this page.');
      return;
    }
    
    // Try standard Web Component methods
    if (typeof drawer.show === 'function') drawer.show();
    else if (typeof drawer.open === 'function') drawer.open();
    
    // Add common state attributes and classes used by Shopify themes
    drawer.setAttribute('open', '');
    drawer.setAttribute('aria-expanded', 'true');
    drawer.classList.add('opened', 'is-active', 'active', 'sidebar-opened');
    
    document.body.classList.add('sidebar-opened', 'cart-drawer-open');
    document.documentElement.classList.add('sidebar-opened', 'cart-drawer-open');
    
    // Dispatch standard theme cart events to fetch updated HTML (unless already dispatched)
    if (!isSilent) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
    }
  },

  closeCartDrawer: function() {
    const drawer = document.getElementById('site-cart');
    if (!drawer) return;
    
    // Try standard Web Component methods
    if (typeof drawer.hide === 'function') drawer.hide();
    else if (typeof drawer.close === 'function') drawer.close();
    
    // Remove common state attributes and classes
    drawer.removeAttribute('open');
    drawer.setAttribute('aria-expanded', 'false');
    drawer.classList.remove('opened', 'is-active', 'active', 'sidebar-opened');
    
    document.body.classList.remove('sidebar-opened', 'cart-drawer-open');
    document.documentElement.classList.remove('sidebar-opened', 'cart-drawer-open');
  }
};

// Global click listener to close cart drawer when clicking outside or on close buttons
document.addEventListener('click', function(e) {
  if (e.target.closest('.site-close-handle') || e.target.closest('[data-action="close-cart"]')) {
    ErgoTheme.closeCartDrawer();
  }
  // Close if clicking outside the drawer content
  const drawer = document.getElementById('site-cart');
  if (drawer && (drawer.classList.contains('opened') || document.body.classList.contains('sidebar-opened') || drawer.hasAttribute('open'))) {
    const isClickInside = drawer.contains(e.target);
    const isClickOnToggle = e.target.closest('#ErgoCartIcon');
    if (!isClickInside && !isClickOnToggle) {
      ErgoTheme.closeCartDrawer();
    }
  }
});

document.addEventListener('DOMContentLoaded', () => {
  ErgoTheme.init();
});
